import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'paymentFormFilled',
  initialState: false,
  reducers: {
    setPaymentFormFilled(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setPaymentFormFilled } = slice.actions;

export default slice.reducer;
